import React, { useCallback, useEffect, useState } from "react";
import * as Styled from "./SelectTemplate.styled";
import { FullScreenModal, getLayoutImage, HeaderLogo, IPlaylistMediaItem, IPlaylistRequestDto, ISelectTemplateProps, LayoutImages, LayoutTemplates } from "../../../../../libs";
import AdPreviewImage from "../../../../../assets/images/layout/AdPreviewImage_01.png";
import { Image } from "react-bootstrap";
import { toast } from "react-toastify";
import { playlistsService } from "../../../../../services";

export const SelectTemplate: React.FC<ISelectTemplateProps> = ({ show, onHide, originalData, data, setData, setLoading, fetchPlaylist, playlist }) => {
    const [selectedLayout, setSelectedLayout] = useState<number>(playlist?.templateId ?? LayoutTemplates.Layout1);

    const hasOrderChanged = (current: IPlaylistMediaItem[], original: IPlaylistMediaItem[]): boolean => {
        if (current.length !== original.length) return true;

        for (let i = 0; i < current.length; i++) {
            if (current[i].mediaId !== original[i].mediaId) return true;
        }

        return false;
    };

    const updatePlaylist = useCallback(async (templateId: number) => {
        const orderChanged = hasOrderChanged(data, originalData);
        const layoutChanged = playlist?.templateId !== templateId;

        if (!orderChanged && !layoutChanged) {
            toast.info("No changes to save.");
            return;
        }

        if (playlist?.playlistId) {
            const updatedPlaylist: IPlaylistRequestDto = {
                title: playlist.title,
                description: playlist.description,
                thumbnails: playlist.thumbnails,
                audience: playlist.audience,
                visibility: playlist.visibility,
                playliststatus: playlist.playliststatus,
                steps: playlist.steps,
                category: "",
                mediaItems: data.map((item) => item.mediaId),
                templateId: templateId,
            };

            try {
                setLoading(true);
                await playlistsService.updatePlaylist(updatedPlaylist, playlist.playlistId);
                
                await fetchPlaylist();
                toast.success("Playlist updated successfully!");
                onHide();
            } catch (error) {
                console.error("Error updating playlist:", error);
                toast.error("Failed to update playlist.");
            } finally {
                setLoading(false);
            }
        }
    }, []);

    // Or, safer if playlist might come later
    useEffect(() => {
        if (show && typeof playlist?.templateId === "number") {
            setSelectedLayout(playlist.templateId);
        }
    }, [show, playlist]);

    return (
        <FullScreenModal
            show={show}
            onHide={onHide}
            header={
                <Styled.ModalHeader closeButton closeVariant="white">
                    <HeaderLogo />
                </Styled.ModalHeader>
            }
            body={
                <Styled.OrderSelectionWrapper>
                    <Styled.LeftSection>

                        <Styled.OrderSelectionRow>
                            <Styled.OrderSelectionCol>
                                <Styled.OrderSelectionHeader>
                                    <Styled.OrderSelectionHeaderText>
                                        Select template
                                    </Styled.OrderSelectionHeaderText>
                                    <Styled.OrderSelectionHeaderActions>
                                        <Styled.CustomButton variant="outline-secondary" onClick={onHide}>
                                            Cancel
                                        </Styled.CustomButton>
                                        <Styled.SaveButton variant="primary"
                                            onClick={() => updatePlaylist(selectedLayout)}
                                        >Save</Styled.SaveButton>
                                    </Styled.OrderSelectionHeaderActions>
                                </Styled.OrderSelectionHeader>
                            </Styled.OrderSelectionCol>
                        </Styled.OrderSelectionRow>
                        <Styled.OrderSelectionRow className="mt-4">
                            <Styled.OrderSelectionCol >
                                <Styled.LayoutCardContainer>
                                    <Styled.LayoutGrid>
                                        {Object.entries(LayoutImages).map(([key, imgSrc]) => {
                                            const templateId = Number(key);
                                            return (
                                                <Styled.LayoutCard
                                                    key={templateId}
                                                    selected={selectedLayout === templateId}
                                                    onClick={() => setSelectedLayout(templateId)}
                                                >
                                                    <Image src={getLayoutImage(templateId)} width={150} />
                                                </Styled.LayoutCard>
                                            );
                                        })}
                                    </Styled.LayoutGrid>

                                </Styled.LayoutCardContainer>


                            </Styled.OrderSelectionCol>
                        </Styled.OrderSelectionRow>


                    </Styled.LeftSection>

                    <Styled.RightSection>
                        <Styled.PreviewWrapper>
                            <Styled.PreviewHeader>Preview</Styled.PreviewHeader>
                            <Image src={AdPreviewImage} width={500} />
                        </Styled.PreviewWrapper>
                    </Styled.RightSection>
                </Styled.OrderSelectionWrapper>
            }
        />
    );
};
